import {
  createStyles, InputLabel, withStyles,
} from '@material-ui/core';

const CustomSelectInputLabel = withStyles(() => createStyles({
  formControl: {
    transform: 'translate(0, 12px) scale(1)',
  },
  shrink: {
    transform: 'translate(14px, -9px) scale(0.75)',
    padding: '0!important',
    border: '5px solid white!important',
    backgroundColor: 'white',
  },
}))(InputLabel);

export default CustomSelectInputLabel;
